export const STATUS_CODES = Object.freeze({
  BAD_REQUEST: 400,
  CREATED: 201,
  CONFLICT: 409,
  FAILED_DEPENDENCY: 424,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
  NO_CONTENT: 204,
  NOT_FOUND: 404,
  OK: 200,
  TOO_MANY_REQUESTS: 429,
  UNAUTHORIZED: 401,
  UNPROCESSABLE_CONTENT: 422,
});
